module.exports = __webpack_public_path__ + "img/image11.6b372b5a.png";